import React from 'react';

const HeroSection = () => {
  return (
    <section id="home" className="min-h-screen bg-gray-100 pt-16">
      <div className="hero min-h-screen">
        <div className="hero-content flex-col lg:flex-row-reverse w-full lg:max-w-7xl lg:mx-auto min-h-screen items-stretch">
          <div className="flex-1 min-h-[200px] lg:min-h-[600px] flex items-center justify-center">
            <img 
              src="/images/profile_pic.jpg" 
              className="w-1/2 aspect-[1/1] object-cover rounded-full lg:w-full lg:h-full lg:rounded-none" 
              alt="Vivek Agarwal Profile"
            />
          </div>
          <div className="flex-1 min-h-[500px] lg:min-h-[600px] text-center lg:text-left flex flex-col justify-center px-6">
            <h1 className="text-4xl lg:text-6xl mb-6">
              <span className="block italic font-semibold leading-relaxed">"A product that tries to do everything, ends up doing nothing."</span>
            </h1>
            <h3 className="text-2xl font-black lg:text-4xl">
              VIVEK AGARWAL
            </h3>
            <h5 className="text-lg font-extralight">
               Product Leader with 9+ years of experience
            </h5>
            <div className="mt-8">
              <a 
                href="#contact" 
                className="btn bg-orange-500 text-white border-orange-500 btn-lg px-8 py-4 text-lg font-semibold hover:bg-black hover:border-black hover:text-white transition-all duration-300"
              >
                Get in touch with me
              </a>
              <div className="flex items-center text-center justify-center lg:justify-start mt-4 text-gray-400 text-sm">
                <span className="material-symbols-outlined mr-1 text-xl">
                  robot_2
                </span>
                Built using Cursor AI. Zero lines of code written.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 